import { BrowserRouter, useRoutes } from "react-router-dom";
import "./App.scss";
import Contact from "./pages/Contact";
import Factories from "./pages/Factories";
import Home from "./pages/Home";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import Investors from "./pages/Solution";
import TermsAndConditions from "./pages/TermsAndConditions";

const Routes = () => {
  return useRoutes([
    {
      path: "/",
      children: [
        {
          path: "/",
          element: <Home />,
        },
        {
          path: "contact",
          element: <Contact />,
        },
        {
          path: "solution/factories",
          element: <Factories />,
        },
        {
          path: "solution/investors",
          element: <Investors />,
        },
        {
          // 2026-05-10 — PLG demo landing page (Phase 8). Replaces the
          // legacy static factories content. The widget calls the
          // orchestrator's /api/demo/* endpoints.
          path: "solution/factories",
          element: <Factories />,
        },
        {
          path: "terms-and-conditions",
          element: <TermsAndConditions />,
        },
        {
          path: "privacy-policy",
          element: <PrivacyPolicy />,
        },
      ],
    },
  ]);
};

function App() {
  return (
    <BrowserRouter>
      <div className="relative">
        {/* <RouterProvider router={router} /> */}
        <Routes />
      </div>
    </BrowserRouter>
  );
}

export default App;
